import React, { Component } from 'react';
import { View, AppHeader, FlatList } from 'core';
import * as actions from 'actions';
import { css, GROUP_ROLES } from 'constants';
import ConvMember from '../right/conv_member';
import { IcoAccount } from 'icons';
import { lang } from 'lang';

class BlockList extends Component {
  render() {
    const { block_list, selected_id, user_id } = this.props;
    const list = Object.values(block_list).filter(f => f.role === GROUP_ROLES.BLOCKED);
    const options = member_id => [
      { icon: IcoAccount, text: lang.UNBLOCK, onPress: () => actions.sendUnblockMember({ conv_id: selected_id, member_id }) }
    ];
    return (
      <View>
        <AppHeader title={lang.BLOCK_LIST} close />
        <FlatList
          keyExtractor={item => item.id}
          data={list}
          renderItem={({ item }) => (
            <ConvMember group_id={selected_id} is_admin={false} user_id={user_id} style={{ padding: 10 }} member={item} options={options(item.id)} />
          )}
          style={styles.container}
        />
      </View>
    );
  }
}
const styles = css({
  container: {
    padding: 10
  }
});
export default BlockList;



// WEBPACK FOOTER //
// ./src/components/modals/block_list.js